// Version : 1.0.0
// Author : AGALYA

import AddressExtraProofActionType from './address-extra-proof.types';

/** ***************** UPDATE ADDRESS EXTRA PROOF START *********************** */
export const updateAddressExtraProofStart = (addressExtraProofIdCredentials: any) => ({
	type: AddressExtraProofActionType.UPDATE_ADDRESS_EXTRA_PROOF_START,
	payload: addressExtraProofIdCredentials,
});

export const updateAddressExtraProofSuccess = (addressExtraProofIdSuccess: any) => ({
	type: AddressExtraProofActionType.UPDATE_ADDRESS_EXTRA_PROOF_SUCCESS,
	payload: addressExtraProofIdSuccess,
});

export const updateAddressExtraProofFailure = (addressExtraProofIdFailure: any) => ({
	type: AddressExtraProofActionType.UPDATE_ADDRESS_EXTRA_PROOF_FAILURE,
	payload: addressExtraProofIdFailure,
});

export const updateAddressExtraProofResponseResetStart = () => ({
	type: AddressExtraProofActionType.UPDATE_ADDRESS_EXTRA_PROOF_RESPONSE_REST_START,
});

export const updateAddressExtraProofResponseChanged = () => ({
	type: AddressExtraProofActionType.UPDATE_ADDRESS_EXTRA_PROOF_RESPONSE_CHANGED,
});
/** ***************** UPDATE ADDRESS EXTRA PROOF END *********************** */
